<template>
    <div class="Pagos" id="Pagosc">

        <div class="container">

            <div class="row justify-content-center">
                <div class="col-12 col-md-10 text-center">
                    <div class="heading pb-4">
                        <h2>Elija su membresía</h2>
                        <h5 class="font-weight-normal lis-light">Selecciona la que más te agrade</h5>
                        <div class="col-12 text-info" v-if="isfree">
                            <strong>
                                <i class="fas fa-bell"></i>
                                Tu suscripción es GRATUITA, para obtener todos los beneficios contrata una de nuestras membresias PREMIUM
                            </strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-md-center">


                <div class="col-12 col-md-6 col-lg-3 mb-5 mb-lg-0 text-center" v-for="plan in listPlans" :key="plan.id_plan">
                    <div class="price-table">
                        <div class="price-header lis-rounded-top py-4 border lis-brd-light" :class="suscription.items.data[0].price.id == plan.id_price ? 'lis-bg-primary' : 'lis-bg-light'">
                            <h5 class="text-uppercase lis-latter-spacing-2">
                                {{plan.descripcion}}
                            </h5>
                            <h1 class="display-5">
                                <sup>$</sup>
                                {{moneda(plan.costo)}}
                                <sup>USD</sup>
                            </h1>
                            <p class="mb-0">
                                {{plan.caracteristica}}
                            </p>
                        </div>
                        <div class="border border-top-0 bg-white py-4" style="height: 290px;">

                            <ul class="lis-line-height-3 text-left">
                                <li v-for="(opc, index) in JSON.parse(plan.opciones)" :key="index"
                                    v-html="opc">
                                </li>
                            </ul>

                        </div>
                        <div class="border border-top-0 bg-white" style="padding: 15px;">
                            <button v-if="suscription.items.data[0].price.id != plan.id_price"
                                    class="btn btn-primary-outline btn-md lis-rounded-circle-50"
                                    data-abc="true"
                                    @click="showModalPago(plan)">
                                <span>
                                    <i class="fas fa-clipboard-check pl-2"></i>
                                    Seleccionar</span>
                            </button>

                            <span v-else class="btn orange btn-md disabled">
                                Tu plan actual
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">
                    <div class="col-sm-12 text-center" style="padding: 20px; font-size: 13px">
                        <span class="text-muted">* El pago de membresia no es reembolsable</span>
                        <br/>
                        <a href="#">Ver política de Cargos y Tarifas</a>
                    </div>
                </div>


            <!-- Modal resumen de pagos -->
            <div class="modal fade" tabindex="-1" role="dialog" id="aplicarPago" aria-hidden='true' data-backdrop='static'>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Detalles del pago</h5>
                        </div>

                        <div class="modal-body p-0">
                            <ul class="list-group list-group-flush mb-4">
                                <li class="list-group-item font-weight-bold">
                                    Membresia <span class="float-right">{{plan.descripcion}}</span>
                                </li>
                                <li class="list-group-item font-weight-bold">
                                    Costo
                                    <span class="float-right">$ {{moneda(plan.costo)}} <sup>USD</sup></span>
                                </li>
                                <!-- Si ya existe una tarjeta guardada -->
                                <li class="list-group-item" v-for="card in listCards" :key="card.id">
                                    <font-icon icon="credit-card"/> Tarjeta
                                    <span class="float-right">
                                        <sup>{{card.brand}}</sup> **** {{card.last4}}
                                    </span>
                                </li>
                                <!-- Si NO existe una tarjeta guardada -->
                                <li class="list-group-item pt-4 pb-0" v-if="!cardSave">
                                    <stripe-element-card
                                        ref="elementRef"
                                        :hidePostalCode="true"
                                        :pk="this.publishKey"
                                        @token="CreateToken"
                                    />
                                </li>
                            </ul>
                        </div>
                         <div class="modal-footer">
                            <button class="btn orange" :disabled="spiner" @click="submit">
                                <span class="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                      v-if="spiner">
                                </span>
                                Aplicar pago
                            </button>
                            <button type="button"
                                    class="btn btn-light"
                                    :disabled="spiner"
                                    @click="$refs.elementRef.clear()"
                                    data-dismiss="modal">
                                Cerrar
                            </button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import { StripeElementCard } from '@vue-stripe/vue-stripe';

import $ from 'jquery'
export default {
    components:{ StripeElementCard },
    mixins: [ globalFunctions ],
    data(){
       return {
        rol: localStorage.rol,
        listPlans: [],
        listCards: [],
        cardSave: false,
        isfree: true,
        plan: {},
        statusUsr: {},
        suscription: {
            items: {
                data: [
                    { price:{ id: null } }
                ]
            },
            status: null
        },
        spiner: false
      }
    },
    computed:{
        ...mapState(['url', 'urlApi', 'publishKey'])
    },
    mounted(){
        this.getListPlans();
        this.getCardList();
        this._getSuscription();
    },
    methods: {

        submit () {

            // Si no hay tarjetas guardadas
            if (!this.cardSave)
                // Obtiene Token de stripe y ejecuta
                // el metodo CreateToken inmediatamente
                this.$refs.elementRef.submit();
            else {
                // Si la suscripcion no ha sio cancelada previamente
                if (this.suscription.status == 'active') {
                    this.updateSuscripion();
                }
                else {
                    this.renewSuscription();
                }
            }

        },

        CreateToken (token) {

            // Si la suscripcion es gratuita
            if (this.isfree) {
                this.newSuscription(token.id);
            }
            else {
                this.spiner = true;
                this.NewCard(token.id);
            }

        },

        getListPlans() {

            let data = {};
            let url = this.urlApi + '/plans';

            this.axios
                .get(url, data)
                .then(response => {
                    this.listPlans = response.data;
                })
                .catch(e => {
                }
            );
        },

        getCardList() {

            let data = {};
            let url = this.urlApi + '/cardlist/' + localStorage.userID;

            this.axios
                .get(url, data)
                .then(response => {
                    if (response.data.length > 0) {
                        this.listCards = response.data;
                        this.cardSave = true;
                    }
                })
                .catch(e => {
                }
            );

        },

        _getSuscription() {

            let data = {};
            let url = this.urlApi + '/'+ localStorage.userID;

            this.axios
                .get(url, data)
                .then(response => {
                    if (response.data && response.data.status == 'active') {
                        this.suscription = response.data;
                        this.isfree = false;
                    }
                    this.validarSuscripcion();
                })
                .catch(e => {
                }
            );

        },

        validarSuscripcion() {

            let data = {};
            let url = this.urlApi + '/validar/' + localStorage.userID;

            this.axios
                .get(url, data)
                .then(response => {
                    this.statusUsr = response.data;
                })
                .catch(e => {
                }
            );
        },

        newSuscription(token) {

            let data = {
                    correo: this.statusUsr.correo,
                    price: this.plan.price,
                    tipo: this.plan.tipo,
                    token: token
                };
            let url = this.urlApi + "/create/" + localStorage.userID;

            this.spiner = true;
            this.axios
                .post(url, data)
                .then(response => {
                    this._getSuscription();
                    this.getCardList();
                    this.spiner = false;
                    $("#aplicarPago").modal('hide');
                    //this.sendEmail(3,data.correo, localStorage.userID);
                    this.enviarCorreo(3, 'Pago por membresía', 0, localStorage.userID);
                    //location.reload();
                }).catch(e => {
                }
            );

        },

        renewSuscription() {

            let data = {
                    id_customer: this.statusUsr.id_customer,
                    price: this.plan.price,
                    tipo: this.plan.tipo
                };
            let url = this.urlApi + "/renew/" + localStorage.userID;

            this.spiner = true;
            this.axios
                .post(url, data)
                .then(response => {
                    this._getSuscription();
                    this.spiner = false;
                    $("#aplicarPago").modal('hide');
                    //location.reload();
                }).catch(e => {
                }
            );

        },

        updateSuscripion() {

            let data = {
                tipo: this.plan.tipo
            };
            let url = this.urlApi + "/extend/" + localStorage.userID + "/" + this.plan.price;

            this.spiner = true;
            this.axios
                .post(url, data)
                .then(response => {
                    this._getSuscription();
                    this.spiner = false;
                    $("#aplicarPago").modal('hide');
                    //location.reload();
                }
            );

        },

        NewCard(token) {

            let data = {token: token};
            let url = this.urlApi + "/card/" + localStorage.userID;

            this.axios
                .post(url, data )
                .then(response => {
                     this.updateSuscripion();
                     this.getCardList();
                })
                .catch(e => {
                }
            );
        },

        showModalPago(elem){

            this.plan = {
                    costo: this.moneda(elem.costo),
                    price: elem.id_price,
                    tipo: elem.id_plan,
                    descripcion: elem.descripcion
                }

            $("#aplicarPago").modal('show');
        },

    }
}
</script>

<style scoped>

.lis-bg-light {
    background-color: #00000005;
}

.lis-light {
    color: #707070;
}

.font-weight-normal {
    font-weight: 400 !important
}

.lis-brd-light {
    border-color: #dadada !important;
    box-shadow: 5px 6px 6px 2px #e9ecef
}

.lis-rounded-top {
    border-top-right-radius: 20px;
    border-top-left-radius: 20px
}

sup {
    position: relative;
    font-size: 55%;
    line-height: 0
}

.btn-primary-outline {
    background-color: transparent;
    color: #ff573b !important;
    border-color: #ff573b
}

.lis-bg-primary {
    background-color: #ff573b;
    color: #fff;
}

.btn-primary:hover,
.btn-primary:focus {
    background-color: #ff573b;
    border-color: #ff573b
}

.btn-primary-outline {
    background-color: transparent;
    color: #ff573b !important;
    border-color: #ff573b
}

.btn-primary-outline:hover,
.btn-primary-outline:focus {
    background-color: #ff573b;
    border-color: #ff573b;
    color: #fff !important
}

</style>



// WEBPACK FOOTER //
// src/components/PagosC.vue